import React, { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { GET } from '../../utils/requests';
import { debounce } from "../../utils/debounce";

const Main = ({ default_value, vendor_id, value, onChange }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (default_value !== undefined) {
      getItemByID(default_value)
    }
  }, [])

  const doDebouncedSearch = (searchTerm) => getSearchVendors(searchTerm)

  const debouncedFetchData = debounce(doDebouncedSearch, 500);

  const getSearchVendors = (searchTerm) => {
    GET({
      url: `/references/items/by_item_number.json?query=${searchTerm}&vendor_id=${vendor_id}`,
      before: () => setOptions([]),
      success: (data) => setOptions(data.records)
    })
  }

  const getItemByID = (id) => {
    GET({
      url: `/references/items/${id}.json?vendor_id=${vendor_id}&item_number=true`,
      success: (data) => doSetValue(data)
    })
  }

  const onSearch = (newValue) => {
    debouncedFetchData(newValue)
  }

  const onLocalChange = (newValue) => {
    doSetValue(newValue)
  }

  const doSetValue = (newValue) => {
    if(onChange) {
      onChange(newValue)
    }
  }

  return (
    <>
      <Autocomplete
        value={value}
        options={options}
        sx={{ width: "100%" }}
        getOptionLabel={(option) => {
          if(typeof option === 'string') {
            return option
          } else if(option?.name) {
            return option.name
          } else {
            return ''
          }
        }}
        filterOptions={(x) => x}
        autoComplete
        includeInputInList
        filterSelectedOptions
        noOptionsText="No items found"
        onChange={(event, newValue) => {
          onLocalChange(newValue)
        }}
        onInputChange={(event, newInputValue) => {
          onSearch(newInputValue)
        }}
        renderInput={(params) => (
          <TextField {...params} fullWidth />
        )}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps} sx={{backgroundColor: 'red !important'}}>
              <Grid container sx={{ alignItems: 'center' }}>
                <Grid item sx={{ width: 'calc(100% - 44px)', wordWrap: 'break-word' }}>
                  <Typography variant="h7" sx={{ fontWeight: "700", letterSpacing: "0.07rem", color: 'text.primary' }}>
                    {option.item_number}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.primary' }}>
                    {option.item_name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {option.uom}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    ${option.item_price}
                  </Typography>
                </Grid>
              </Grid>
            </li>
          );
        }}
      />
    </>
  )
}

export default Main;
